export function formatMoney(value) {
  if (value == null || value === "") return "";
  return "£" + Number(value).toLocaleString("en-GB");
}

const FREQ = {
  pcm: "pcm",
  pw: "pw",
  "Per calendar month": "pcm",
  "Per week": "pw",
};

// Returns a display price like "Guide price £685,000" or "£2,200 pcm"
export function priceLabel(p) {
  if (!p) return "";
  if (p.price_on_application || (!p.price && p.price !== 0)) {
    return p.price_qualifier === "Price on application" || !p.price ? "Price on application" : "";
  }
  const money = formatMoney(p.price);
  const q = p.price_qualifier;
  if (p.listing_type === "let" || FREQ[q] || p.rental_frequency) {
    const freq = FREQ[q] || FREQ[p.rental_frequency] || p.rental_frequency || "pcm";
    return `${money} ${freq}`;
  }
  const prefixQualifiers = ["Guide price", "Offers over", "Offers in excess of", "From", "Starting from", "Fixed price"];
  if (q && prefixQualifiers.includes(q)) {
    if (q === "Fixed price") return money;
    return `${q} ${money}`;
  }
  return money;
}

export function statusColor(status) {
  const map = {
    "For Sale": "bg-[#C81D35] text-white",
    "To Let": "bg-[#111827] text-white",
    "Under Offer": "bg-amber-500 text-white",
    "Sale Agreed": "bg-amber-600 text-white",
    "Sold": "bg-gray-700 text-white",
    "Sold Subject to Contract": "bg-gray-700 text-white",
    "Let Agreed": "bg-gray-700 text-white",
    "Let": "bg-gray-700 text-white",
    "Coming Soon": "bg-[#C5A059] text-white",
    "Reserved": "bg-amber-500 text-white",
  };
  return map[status] || "bg-[#111827] text-white";
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
